import { BLAdmin } from '@/types/user';
import { jwtDecode } from '@/utils/jwt/jwt-decode';
import { getStorageItem } from '@/utils/storage/local-storage';
import { StoredTokens } from '@/utils/storage/types';
import { AuthState } from './types';

const initialToken = typeof localStorage !== 'undefined' ? getStorageItem(StoredTokens.currentUser) ?? null : null;
const initialTwoFactor =
  typeof localStorage !== 'undefined' ? getStorageItem(StoredTokens.storedTwoFactor) ?? null : null;

export const initialState: AuthState = {
  testVal: 'test',
  channelsInfo: [],
  channelsInfoLoading: false,
  channelsInfoFailed: false,
  awaitCode: false,
  changingChannels: false,
  channels: [],
  channelSSO: {},
  forgotPasswordError: '',
  forgotPasswordLoading: false,
  forgotPasswordSuccess: false,
  greenroomLoginError: '',
  onboardedLoading: false,
  phone_hash: null,
  reduced_user: { email: '', channels_using_sso: [], channelId: 0, channels: undefined },
  request_phone: false,
  signInFailure: '',
  signingIn: false,
  temp_profile: null,
  token: initialToken,
  two_factor_stored: initialTwoFactor,
  updateChannelError: false,
  updatePasswordError: '',
  updatePasswordLoading: false,
  updatePasswordSuccess: false,
  user: initialToken ? (jwtDecode(initialToken) as BLAdmin) : null,
  presenterAuthType: null,
  oauthFlowToken: null,
  oauthFlowTokenForRedirect: null,
  oauthFlowTokenError: null,
  gettingChannelsInfo: false,
  gettingChannelsInfoError: '',
};
